import clsx from 'clsx';

import styles from './ResultBox.module.scss';
import TextButton from '../text-button/TextButton';
import IconButton from '../icon-button/IconButton';
import { useEffect, useRef } from 'react';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';

function ResultBox({
    className,
    question,
    result,
    hideAnswer,
    handleOnClickContinue,
    handleOnClickAnswer,
    ...rest
}) {
    const { t } = useTranslation();
    const handleKeyDownOnResult = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleOnClickContinue();
        }
    };

    // Mỗi lần hiện result
    const hiddenInputRef = useRef(null);
    const resultDivRef = useRef(null);
    useEffect(() => {
        // focus vào input ẩn để bắt sự kiện phím
        if (hiddenInputRef.current) {
            hiddenInputRef.current.focus();
        }
        // scroll đến div result
        if (resultDivRef.current) {
            resultDivRef.current.scrollIntoView();
        }
    }, []);
    return (
        <div
            {...rest}
            ref={resultDivRef}
            className={clsx(styles.resultWrapper, getStyleResult(result))}
        >
            <div className={clsx(styles.result, getStyleResult(result))}>
                {/* do css flex column-reverse nên thực tự thẻ hơi ngược  */}
                {/* action */}
                <div className={clsx(styles.action)}>
                    <TextButton
                        className={clsx(
                            styles.btnContinue,
                            getStyleResult(result),
                        )}
                        onClick={handleOnClickContinue}
                    >
                        {t('continue')}
                    </TextButton>
                </div>
                {/* ghi chú nếu có */}
                {question.notes && (
                    <div
                        className={clsx(styles.answer, getStyleResult(result))}
                    >
                        <div className={clsx(styles.label)}>Lưu ý:</div>
                        <div className={clsx(styles.answerContent)}>
                            {question.notes.map((note, index) => {
                                return <div key={`note_${index}`}>{note}</div>;
                            })}
                        </div>
                    </div>
                )}
                {/* Các đáp án */}
                {!hideAnswer && (
                    <div
                        className={clsx(styles.answer, getStyleResult(result))}
                    >
                        <div className={clsx(styles.label)}>{t('answer')}:</div>
                        {question.answer.map((list, index) => {
                            return (
                                <div
                                    onClick={(e) => {
                                        if (handleOnClickAnswer)
                                            handleOnClickAnswer(e, list);
                                    }}
                                    key={`answer_no_${index}`}
                                    className={clsx(styles.answerContent)}
                                >
                                    <i className="fa-solid fa-arrow-right-long"></i>
                                    {' ' + joinAnswerList(list)}
                                </div>
                            );
                        })}
                    </div>
                )}
                {/* thông báo kết quả */}
                <div className={clsx(styles.group, getStyleResult(result))}>
                    <IconButton
                        className={clsx(styles.icon, getStyleResult(result))}
                    >
                        {getIconResult(result)}
                    </IconButton>
                    <div
                        className={clsx(styles.tittle, getStyleResult(result))}
                    >
                        {getTextResult(result)}
                    </div>
                </div>
            </div>
            {/* Lúc đầu dùng để che ko cho thao tác --> ko dùng nữa */}
            {/* Chỉ chứa 1 input checkbox để bắt sự kiện key down */}
            <div className={clsx(styles.fill)}>
                <input
                    ref={hiddenInputRef}
                    type="checkbox"
                    onKeyDown={handleKeyDownOnResult}
                    className={clsx(styles.hidden)}
                />
            </div>
        </div>
    );
}

export default ResultBox;

const getStyleResult = (result) => {
    return result === 'wrong'
        ? styles.wrong
        : result === 'right'
        ? styles.right
        : styles.noCheck;
};

const getTextResult = (result) => {
    return result === 'wrong'
        ? t('incorrect') + '!'
        : result === 'right'
        ? t('correct') + '!'
        : t('note') + ':';
};

const getIconResult = (result) => {
    return result === 'wrong' ? (
        <i className="fa-regular fa-circle-xmark"></i>
    ) : result === 'right' ? (
        <i className="fa-solid fa-thumbs-up"></i>
    ) : (
        <i className="fa-solid fa-wand-magic-sparkles"></i>
    );
};

const joinAnswerList = (list) => {
    if (!Array.isArray(list)) return list;
    const kq = [];
    list.forEach((answer) => {
        if (Array.isArray(answer)) kq.push(answer.join('/'));
        else kq.push(answer);
    });
    return kq.join(' - ');
};
